import React from 'react';
import ReactDOM from 'react-dom/client';
import './App.css';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { ThemeProvider, createTheme } from '@mui/material/styles';

// ✅ Auth keys are now written to BOTH sessionStorage and localStorage during login.
// No localStorage interceptor needed — removed because it caused silent failures on Safari (iPhone/MacBook).


const root = ReactDOM.createRoot(document.getElementById('root'));
const theme = createTheme();
root.render(
  <ThemeProvider theme={theme}>
    <App />
  </ThemeProvider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
